import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { PaginationComponent } from "../common/PaginationComponent";
import { getStakeholderList } from "../../../api/casp/stakeholder";
import Search from "../common/Search";
import { PerPage } from "../../../constants/Common";
import BreadCrumb from "../../Common/BreadCrumb";
import { Button, Container } from "reactstrap";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import axios from "axios";
import { toast } from "react-toastify";

const StakeholderList = ({ t }) => {
  const columns = [
    {
      field: "index",
      headerName: "#",
      width: 100,
      filterable: false,
      sortable: false
    },
    {
      field: "name",
      headerName: t("Name"),
      width: 200,
      filterable: false,
      sortable: false
    },
    {
      field: "email",
      headerName: t("Email"),
      width: 200,
      filterable: false,
      sortable: false
    },
    {
      field: "communicationState",
      headerName: t("State of Communication"),
      width: 200,
      filterable: true,
      sortable: false
    },
    {
      field: "project_name",
      headerName: t("Startup Name"),
      width: 200,
      filterable: true,
      sortable: false
    },
    {
      field: "group",
      headerName: t("Group"),
      width: 200,
      filterable: false,
      sortable: false
    },
    // {
    //   field: "type",
    //   headerName: t("Type"),
    //   width: 200,
    //   filterable: false,
    //   sortable: false,
    //   valueGetter: (params) => {
    //     if (params.value === 'others') {
    //       return params.row.customType;
    //     }
    //     return params.value;
    //   },
    // },
    {
      field: "contactNo",
      headerName: t("Contact No."),
      width: 200,
      filterable: false,
      sortable: false,
    },
  ];
  const [page, setPage] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(false);
  const [stakeholderList, setStakeholderList] = useState([]);
  const navigate = useNavigate();
  const [search, setSearch] = useState("")
  const loggedInUser = useSelector((state) => state.Profile.user);

  const location = useLocation()

  useEffect(() => {
    const filterData = location?.state?.filterData ? JSON.parse(location.state?.filterData) : {}
    fetchStakeholderList({ ...filterData });
  }, [triggerData, location?.state?.filterData]);

  const fetchStakeholderList = async (params = {}) => {
    setIsLoading(true)
    try {
      if (params) {
        params = {
          ...params,
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      } else {
        params = {
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      }
      let level = ((page + 1) - 1) * rowsPerPage
      const res = (await getStakeholderList(params)).data.data;
      if (res.data.length > 0) {
        setStakeholderList(res.data.map((stakeholder) => ({
          index: ++level,
          id: stakeholder.id,
          name: stakeholder.name,
          email: stakeholder.email,
          project_name: stakeholder.projects[0]?.project?.name,
          communicationState: stakeholder.communicationState,
          group: stakeholder.group,
          contactNo: stakeholder.contactNo
        })));
        setTotalRows(res.meta.total);
      } else {
        setStakeholderList([]);
        setTotalRows(0);
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    } finally {
      setIsLoading(false);
    }
  }

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    setTriggerData(+new Date());
  };

  const getRowId = (row) => row.id;

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
    setTriggerData(+new Date());
  };

  function handleInitDownload() {
    axios.get('/Offtakers-csv',
      {
        responseType: 'blob'
      }
    )
      .then(response => {
        // Use the Blob object as needed (e.g., create a downloadable link)
        const blob = response; // Access the Blob data
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Offtakers_export_list_${(new Date()).toISOString().split('T')[0]}`; // Set desired filename
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        toast.error(error.message);
      });
  }

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center ongoingProjectsPg">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb title={t("Offtaker List")} />
            </div>


            <div className="d-flex justify-content-end ongoingSearchField">
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
              <Button className="edit_button d-flex justify-content-center px-3 ms-2" onClick={handleInitDownload}> <FileDownloadIcon />Export</Button>
            </div>
          </div>
          <div className="accordionTable my-4" style={{ width: "100%" }}>
            {stakeholderList.length > 0 && (
              <DataGrid
                rows={stakeholderList}
                columns={columns}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={totalRows}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
              />
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(StakeholderList)
